import React from 'react';
import Routes from '../src/components/Routes';

const App = () => <Routes />;

export default App;